import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CustomvariableComponent } from './customvariable/customvariable.component';
import Quill from 'quill'
import { EdsourcecodeComponent } from './edsourcecode/edsourcecode.component';

var DirectionAttribute = Quill.import('attributors/attribute/direction');
Quill.register(DirectionAttribute, true);
var AlignClass = Quill.import('attributors/class/align');
Quill.register(AlignClass, true);
var BackgroundClass = Quill.import('attributors/class/background');
Quill.register(BackgroundClass, true);
var ColorClass = Quill.import('attributors/class/color');
Quill.register(ColorClass, true);
var DirectionClass = Quill.import('attributors/class/direction');
Quill.register(DirectionClass, true);
var FontClass = Quill.import('attributors/class/font');
Quill.register(FontClass, true);
var SizeClass = Quill.import('attributors/class/size');
Quill.register(SizeClass, true);
var AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);
var BackgroundStyle = Quill.import('attributors/style/background');
Quill.register(BackgroundStyle, true);
var ColorStyle = Quill.import('attributors/style/color');
Quill.register(ColorStyle, true);
var DirectionStyle = Quill.import('attributors/style/direction');
Quill.register(DirectionStyle, true);
var FontStyle = Quill.import('attributors/style/font');
Quill.register(FontStyle, true);
var SizeStyle = Quill.import('attributors/style/size');
Quill.register(SizeStyle, true);

const BlockEmbed = Quill.import('blots/block/embed');

class keepHTML extends BlockEmbed {
  static create(node) {
    return node;
  }
  static value(node) {
    return node;
  }
};

keepHTML.blotName = 'keepHTML';
keepHTML.className = 'keepHTML';
keepHTML.tagName = 'div';

Quill.register(keepHTML);

let Parchment = Quill.import ('parchment');
let List = Parchment.query('list');

let NuggetidAttributor = new Parchment.Attributor.Attribute('nuggetid', 'nuggetid', { 
});

class NuggetList extends List {
  format(name, value) {
    this.domNode.setAttribute('nuggetid', value);
  }
}
NuggetList.tagName = 'UL';
NuggetList.className = 'nugget';
NuggetList.allowedChildren.push(NuggetList);

Quill.register(NuggetidAttributor);
Quill.register(NuggetList, true);

@Component({
  selector: 'app-scripteditor',
  templateUrl: './scripteditor.component.html',
  styleUrls: ['./scripteditor.component.css']
})
export class ScripteditorComponent implements OnInit {

  public leadValue:any;  
  constructor(public dialog: MatDialog) { }
  @Output() public editorscript = new EventEmitter<any>();
  @Input() public editscripteditor:string;
  @Input() public campaignId:any;
  @Input() public dialerCrm_lebel:any;
  ngOnInit() {
    console.log("campaignId")
    console.log(this.campaignId)
    /* this.editor = new Quill('#editor', {
      modules: {
        'toolbar': [
          [{ 'font': [] }, { 'size': [] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'script': 'super' }, { 'script': 'sub' }],
          [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block'],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
          ['direction', { 'align': [] }],
          ['link', 'image', 'video']
        ]
      },
      theme: 'snow'
    }) */
     console.log(this.editscripteditor);
  }

  validateChange(event:any)
  {
    if(event!==null && event!==undefined)
    {
      console.log(event.html);
      this.editorscript.emit(event.html);
    }
     
  }

  onclickMenu()
  {
    const dialogRef = this.dialog.open(CustomvariableComponent, {
      disableClose: true,
      width: '770px', data:{crm_lbel:this.dialerCrm_lebel,campaign:this.campaignId}
    });
    dialogRef.afterClosed().subscribe(result => {
       if(result!=null && result!=undefined){
        var sel, curspos;
        sel = window.getSelection();
        curspos= sel.getRangeAt(0);
        console.log(curspos);
        this.leadValue= curspos.insertNode(document.createTextNode('{'+result.leadType.toUpperCase()+'}'));
         console.log('The dialog was closed');
        }
     }); 
  }

  onSourcecode()
  {    
    const dialogRef = this.dialog.open(EdsourcecodeComponent, {
      disableClose: true,
      width: '800px', 
      data:this.editscripteditor
    });
    dialogRef.afterClosed().subscribe(result => {
       console.log(result.sourcecode);
       if(result!=null && result!=undefined){
        this.editscripteditor=result.sourcecode ;
         console.log('The dialog was closed');
        }
     }); 
  }

}
